import type { ReactNode } from 'react'

const joinClassNames = (...classNames: Array<string | null | undefined | false>) =>
  classNames.filter(Boolean).join(' ')

type Tone = 'default' | 'success' | 'warning' | 'info'

const toneClasses: Record<Tone, string> = {
  default: 'text-(--color-text-primary)',
  success: 'text-(--color-status-success)',
  warning: 'text-(--color-status-warning)',
  info: 'text-(--color-status-info)',
}

type CustomerAreaMetricCardProps = {
  label: string
  value: ReactNode
  meta?: string
  icon?: ReactNode
  tone?: Tone
}

export const CustomerAreaMetricCard = ({
  label,
  value,
  meta,
  icon,
  tone = 'default',
}: CustomerAreaMetricCardProps) => (
  <article className="ca-card-shell ca-theme-transition px-5 py-4">
    <div className="flex items-start justify-between gap-2">
      <p className="text-[11px] font-medium uppercase tracking-wide text-(--color-text-muted)">{label}</p>
      {icon ? <div className="text-(--color-text-muted)">{icon}</div> : null}
    </div>
    <p className={joinClassNames('mt-2 text-2xl leading-none font-semibold', toneClasses[tone])}>{value}</p>
    {meta ? <p className="mt-2 text-xs text-(--color-text-muted)">{meta}</p> : null}
  </article>
)
